import classNames from 'clsx';
import React from 'react';
import type { ReactElement } from 'react';

import type { CasinoIcon } from '@swf/casino';
import ExclusiveSquare from '@swf/core/assets/casino/exclusive-tag-icnSquare.embed.svg';
import ExclusiveWide from '@swf/core/assets/casino/exclusive-tag-icnWide.svg';
import { MarketingOverlayTag, MosaicContext } from '@swf/core/types/CasinoGame';
import type { CasinoGame } from '@swf/core/types/CasinoGame';

import styles from './IconOverlay.scss';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type OverlayType = ReactElement<any, any> | null;

export interface Props {
  tags?: CasinoGame['tags'];
  icon?: CasinoIcon;
  mosaicHint?: MosaicContext;
}

const IconOverlay: React.FC<Props> = ({ tags, icon = 'icnSquare', mosaicHint }) => {
  const mapped = tags?.map((current: string): OverlayType => {
    if (current.match(MarketingOverlayTag.Exclusive)) {
      const cls = classNames({
        [styles.exclusiveOverlay]: true,
        [styles[icon as keyof typeof styles]]: true,
        [styles.icnHeroSquare]: mosaicHint === MosaicContext.BigIcon,
        [styles.icnSquareSmall]: mosaicHint === MosaicContext.SmallIcon
      });
      switch (icon) {
        case 'icnWide':
          return <ExclusiveWide className={cls} />;
        case 'icnSquare':
          return <img alt="" src={`${ExclusiveSquare}`} className={cls} />;
      }
    }
    // TODO If gif is required, return  <img className={styles.overlayIcon} alt="" src={result} />
    return null;
  });

  const result = mapped?.reduce((acc: OverlayType, current) => acc || current, null) || null;
  return result;
};

export default IconOverlay;
